import React from "react";
import { Modal, Box, Grid, TextField, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../redux/common/actions";
import moment from "moment-timezone";
import CloseButton from "../../common/button/closeButton";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";

export default function ProjectEditModel() {
  const dispatch = useDispatch();

  const { showModal } = useSelector((state) => state.commonReducer);

  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "PEM", data: null },
    });
  };

  return (
    <Modal
      open={showModal?.show && showModal?.method === "PEM"}
      // onClose={handleClose}
      aria-labelledby="candidate-details-modal-title"
      aria-describedby="candidate-details-modal-description"
    >
      <Box
        p={2}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minWidth:"80%",
          maxWidth: "80%",
          maxHeight: "90vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          overflow: "auto",
        }}
      >
        <h2 style={{ color: "#3F41D1" }} >
          Edit project
        </h2>
        <Box
          mt={2}
          sx={{
            maxHeight: "60vh",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            },
          }}
        >

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
            sx={{ fontWeight: "bold" }}
            variant="subtitle1"
            gutterBottom
          >
            Project Name
          </Typography>

              <TextField
                label="Project name"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
            sx={{ fontWeight: "bold" }}
            variant="subtitle1"
            gutterBottom
          >
            Course Name
          </Typography>

              <TextField
                label="Course name"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
            sx={{ fontWeight: "bold" }}
            variant="subtitle1"
            gutterBottom
          >
            Customer SPOC
          </Typography>

              <TextField
                label="Customer SPOC"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
            sx={{ fontWeight: "bold" }}
            variant="subtitle1"
            gutterBottom
          >
            Contact No
          </Typography>

              <TextField
                label="Contact no"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
            sx={{ fontWeight: "bold" }}
            variant="subtitle1"
            gutterBottom
          >
            Project Description
          </Typography>

              <TextField
                label="Project description"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
            sx={{ fontWeight: "bold" }}
            variant="subtitle1"
            gutterBottom
          >
            Exam Mode
          </Typography>

              <TextField
                label="Exam Mode"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2,gap:2 }}>
          <CloseButton name={"Close"} handleClose={handleClose} />
          {MauvelousPrimaryButton({title:"submit"})}
        </Box>
      </Box>
    </Modal>
  );
}
